import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TrapViewControllerDelegate, TrapViewController } from "../../Screen/Trap/TrapViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { TrapViewModel } from '../../Screen/Trap/TrapViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class TrapCoordinator implements IndexCoordinatorDelegate, TrapViewControllerDelegate, TableGenericViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepdenguearmadilha")
        return (<ProtectedRoute requiredPermissions={['dengue.armadilha.*']} path="/:base/dengue/armadilha" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'dengue.armadilha.adicionar',
                    edit: 'dengue.armadilha.editar',
                    delete: 'dengue.armadilha.excluir',
                }}
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Armadilha"}
            />)
        }} />)
    }

    private routeForm(): JSX.Element {
        var viewModel = new TrapViewModel()
        return (<ProtectedRoute requiredPermissions={['dengue.armadilha.adicionar', 'dengue.armadilha.editar']} path="/:base/dengue/armadilha/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<TrapViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdenguearmadilha") {
            navigation.history.push(`armadilha/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if (viewModel.getTable() == "gepdenguearmadilha") {
            navigation.history.push(`armadilha/cad/${idSelection}`);
            return;
        }
    }

}